module.exports = __webpack_public_path__ + "vertical.270b3bfefdcec54be44181d0ff5ab69d.png";